module.exports = __webpack_public_path__ + "static/media/arrowDown.02311fe7.svg";